import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const RISE = {
  hidden: { y: "110%" },
  show: (i) => ({
    y: "0%",
    transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.25 + i * 0.12 },
  }),
};

export default function Hero({ onQuote }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
  const imgScale = useTransform(scrollYProgress, [0, 1], [1, 1.15]);

  const lines = ["PRECISION", "INTERIOR", "PAINTING"];

  return (
    <section ref={ref} className="relative min-h-screen pt-28 pb-16 overflow-hidden grain" data-testid="hero">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15, duration: 0.6 }}
            className="font-mono2 text-xs tracking-[0.25em] text-[#005CEE] mb-6"
          >
            OUTDOEM MAINTENANCE SERVICES — EST. CRAFT
          </motion.p>

          <h1 className="font-head font-extrabold tracking-tighter leading-[0.92] text-[15vw] sm:text-8xl lg:text-[7.5rem]">
            {lines.map((line, i) => (
              <span key={line} className="line-mask">
                <motion.span custom={i} variants={RISE} initial="hidden" animate="show" className="block">
                  {line}
                </motion.span>
              </span>
            ))}
          </h1>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9, duration: 0.7 }}
            className="mt-8 max-w-md"
          >
            <p className="text-base text-[#8A8A85] leading-relaxed">
              Flawless walls, ceilings and trim — priced honestly at{" "}
              <span className="text-[#111] font-mono2">$1.80 / sq ft</span>. Get an instant estimate and
              book your crew in minutes.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <button onClick={onQuote} className="btn-primary px-8 py-4 text-sm font-semibold" data-testid="hero-quote-btn">
                Get Instant Quote →
              </button>
              <a href="#work" className="text-sm font-medium underline underline-offset-4 decoration-[#8A8A85] hover:decoration-[#111]">
                See our work
              </a>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.94 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.6, duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-5 relative"
        >
          <div className="frame-arch h-[420px] sm:h-[520px] relative shadow-2xl">
            <motion.img
              style={{ y: imgY, scale: imgScale }}
              src="https://images.pexels.com/photos/4981780/pexels-photo-4981780.jpeg"
              alt="Professional painter"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-5 -left-5 bg-[#111] text-[#F6F6F2] px-6 py-4 rounded-2xl shadow-xl">
            <p className="font-mono2 text-3xl leading-none">$1.80</p>
            <p className="text-[10px] tracking-widest text-[#8A8A85] mt-1">PER SQUARE FOOT</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
